import React from 'react';

export const Announcement: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.33333 4H9V10H4.33333C3.04467 10 2 8.95533 2 7.66667V6.33333C2 5.04467 3.04467 4 4.33333 4Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 4L11.6842 2.50396C12.0972 2.27382 12.6011 2.27954 13.0087 2.519C13.4163 2.75846 13.6667 3.19584 13.6667 3.66858V10.3314C13.6667 10.8042 13.4163 11.2416 13.0087 11.4811C12.6011 11.7205 12.0971 11.7263 11.6842 11.4961L9 10"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 9.97678L5.24423 13.0873C5.46471 13.6386 5.99858 14 6.59226 14V14C7.07403 14 7.52442 13.761 7.79451 13.3621C8.0646 12.9632 8.11921 12.4562 7.94029 12.0089L7.13673 10"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
